import { graphql } from '@app/graphql/types';
import { useQuery } from '@apollo/client';
import { DocumentNode } from 'graphql';
import { BranchItemFragment } from '@app/graphql/types/graphql';

interface GetBranchQuery {
  storefront_branch: BranchItemFragment | null;
}

export const GET_BRANCH = graphql(`
  query GetBranch($branchID: ID!) {
    storefront_branch(id: $branchID) {
      ...BranchItem
    }
  }
`) as DocumentNode;

export function useBranch(branchID: string) {
  const { data, loading, error } = useQuery<GetBranchQuery>(GET_BRANCH, {
    variables: {
      branchID,
    },
  });

  return {
    branch: data?.storefront_branch,
    loading,
    error,
  };
}
